import React from 'react';
import loadable from '@loadable/component';

const ContactRedirect = loadable(() => import('containers/ContactRedirect/ContactRedirect'));

export default () => ({
  path: 'contact',
  component: props => <ContactRedirect {...props} />,
});
